import React from 'react';
import styled from 'styled-components';
import darkTheme from '@digital-hig/theme-data/lib/build/json/lightTheme/nestedRoles.json';
import { Trans } from '@lingui/macro';
import { PropTypes } from 'prop-types';

const InfoBox = ({ boxData }) => (
  <div
    className="jest-item-container dhig-grid dhig-gap-4 dhig-grid-cols-3 sm:dhig-grid-cols-1 md:dhig-grid-cols-3 lg:dhig-grid-cols-3 dhig-pt-4"
    style={{ minHeight: 70 }}
  >
    {boxData.length
      ? boxData.map((item, index) => (
          <InfoBoxSingle
            key={item.title}
            className={
              index === boxData.length - 1
                ? 'jest-item no-hover'
                : 'jest-item md:dhig-mr-4 lg:dhig-mr-5 no-hover'
            }
          >
            <a
              href={encodeURI(item.url)}
              className="dhig-typography-headline-smaller infobox-title"
              data-wat-loc="banner links"
              data-wat-val={item.title.toLowerCase()}
            >
              {item.title}
            </a>
            <p className="dhig-typography-body-copy-small infobox-desc dhig-mt-1 dhig-mb-2">
              {item.description ? (
                item.description
              ) : (
                <Trans>Get detailed online Help for using your software.</Trans>
              )}
            </p>
          </InfoBoxSingle>
        ))
      : null}
  </div>
);

const InfoBoxSingle = styled.div`
  p {
    color: ${darkTheme.tokens.colors.textOnBackground};
  }
`;

InfoBox.propTypes = {
  /**
   * Array of objects with title, url and description for boxData
   */
  boxData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      description: PropTypes.string
    })
  ).isRequired
};

export default InfoBox;
